import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const invitations_sent_by_client = async (
  id,
  type,
  response,
  page = 0,
  limit = "",
  search = ""
) => {
  const requestObj = {
    path: `api/app_api/invitation_by_client/${id}?user_type=${type}&response=${response}&page=${page}&search=${search}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const received_invitations = async (email) => {
  const requestObj = {
    path: `api/app_api/get_invitation_against_user/${email}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const verify_invited_user_email = async (data) => {
  const requestObj = {
    path: `api/app_api/verify_invited_to_user`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const send_invitation_to_user = async (data) => {
  const requestObj = {
    path: `api/app_api/send_invitation_to_user`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const edit_access_of_invitation = async (id, data) => {
  const requestObj = {
    path: `api/app_api/update_invited_user_access/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_user = async (id) => {
  const requestObj = {
    path: `api/app_api/delete_invited_user/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const invitation_accept_or_reject = async (id, data) => {
  const requestObj = {
    path: `api/app_api/update_invitation_against_user/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const invitation_resend = async (id) => {
  const requestObj = {
    path: `api/app_api/re_send_invitation_to_user/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const switch_profile = async (data) => {
  const requestObj = {
    path: `api/app_api/switch_profile`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
